import React, { createContext, useState, useEffect, useCallback } from "react";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";
import { useAuth } from "../hooks/useAuth";

export const CarContext = createContext({});

export const CarProvider = ({ children }) => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchCars = useCallback(async (params) => {
    try {
      setLoading(true);
      let urlParams = "";
      if (params) {
        Object.keys(params).forEach(function (key, index) {
          urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
        });
      }
      let url = `cars${urlParams}`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setCars(response.data.cars);

            //   if(response.data.cars.length > 0 && auth.currentCar) {
            //     setActiveCar(response.data.cars.find(car => car._id === auth.currentCar));
            //   }
          } else {
            setCars([]);
          }
        })
        .catch((err) => {
          if (err.response) {
            setCars([]);
          }
        });
    } catch (error) {
      setCars([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (auth && auth.token) {
      fetchCars();
    }
  }, [fetchCars, auth]);

  return (
    <CarContext.Provider value={{ cars, fetchCars, loading }}>
      {children}
    </CarContext.Provider>
  );
};
